import type { Questionnaire } from '@medplum/fhirtypes'

export const editTaskDescriptionQuestionnaire = {
  resourceType: 'Questionnaire',
  status: 'active',
  url: 'https://www.seenhealth.org/fhir/Questionnaire/task-change-description',
  id: 'task-change-description',
  title: 'Change Task Description',
  item: [
    {
      linkId: 'description',
      text: 'Description',
      type: 'string',
      required: true,
    },
  ] as const,
} satisfies Questionnaire
